import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { ShopTabs } from './Constants';
import Screens from '../index';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { ShopTypes as paramShopTypes } from '../../utils/routeParamConstants';
import buyClickedHandler from './buyClickedHandler';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Utils from '../../utils';
import audio from '../../utils/audio';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import NotificationContext from '../../context/NotificationContext';
import { PLATFORM } from '../../constants';
var Shop = /*#__PURE__*/function (_Component) {
  function Shop(props) {
    var _this;
    _classCallCheck(this, Shop);
    _this = _callSuper(this, Shop, [props]);
    _this._buyServerHandler = buyClickedHandler;
    _this.checkBillingProfile = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var getBillingProfiles;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getBillingProfiles = _this.props.getBillingProfiles;
            _context.next = 3;
            return getBillingProfiles();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    _this._getPackages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var getCurrencyPackages, paramShopType, shopTab, _this$props, promoLink, setShopListCoins, isOutOfCoinsPurchase, isLTOPurchase, setShopListVip, currencyPackages, coinItems, vipItems, promoApplied, promoBoostDialogType, usedPromoBefore, saleEndDate, showPromoBoost;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            getCurrencyPackages = _this.props.getCurrencyPackages;
            _context2.prev = 1;
            /**
             * @type {import("../../api/Constants").CurrencyPackagesResponse}
             */
            /** This bit automatically tabs over if the param is present. */
            paramShopType = QueryParamsProxy.findParam(RouteParamConstants.PARAM_SHOP_TYPE, paramShopTypes.COINS);
            _context2.t0 = paramShopType;
            _context2.next = _context2.t0 === paramShopTypes.COINS ? 6 : _context2.t0 === paramShopTypes.VIP ? 8 : 10;
            break;
          case 6:
            shopTab = ShopTabs.COINS;
            return _context2.abrupt("break", 11);
          case 8:
            shopTab = ShopTabs.VIP;
            return _context2.abrupt("break", 11);
          case 10:
            console.error('Invalid ShopType.');
          case 11:
            _this$props = _this.props, promoLink = _this$props.promoLink, setShopListCoins = _this$props.setShopListCoins, isOutOfCoinsPurchase = _this$props.isOutOfCoinsPurchase, isLTOPurchase = _this$props.isLTOPurchase, setShopListVip = _this$props.setShopListVip;
            if (!(promoLink !== null && promoLink !== void 0 && promoLink.isFake)) {
              _context2.next = 16;
              break;
            }
            _context2.t1 = promoLink === null || promoLink === void 0 ? void 0 : promoLink.fakeCurrencyPackages;
            _context2.next = 19;
            break;
          case 16:
            _context2.next = 18;
            return getCurrencyPackages((promoLink === null || promoLink === void 0 ? void 0 : promoLink.code) || null);
          case 18:
            _context2.t1 = _context2.sent;
          case 19:
            currencyPackages = _context2.t1;
            currencyPackages.PAYMENT_PROVIDER !== _this.props.paymentProvider && _this.props.setPaymentProvider(currencyPackages.PAYMENT_PROVIDER);
            coinItems = currencyPackages.PACKAGE_LIST.coins.items;
            vipItems = currencyPackages.PACKAGE_LIST.vip_room_access.items;
            promoApplied = currencyPackages.PACKAGE_LIST.coins.promo_applied;
            _this.promoApplied = promoApplied === 'yes' ? true : false;
            promoBoostDialogType = null;
            usedPromoBefore = false;
            if (promoLink.code) _this.props.lastPromoCode === promoLink.code ? usedPromoBefore = true : _this.props.setLastPromoCode(promoLink.code);
            if (promoApplied === 'yes' && !promoLink.active) {
              !usedPromoBefore ? promoBoostDialogType = 'success' : promoBoostDialogType = 'error';
            } else if (promoApplied === 'no') {
              promoBoostDialogType = 'error';
            }
            saleEndDate = new Date();
            saleEndDate.setSeconds(saleEndDate.getSeconds() + currencyPackages.PACKAGE_LIST.coins.time_left || 0);
            showPromoBoost = promoApplied === 'yes' && promoLink.active;
            setShopListCoins(coinItems);
            isOutOfCoinsPurchase(false); // Making out-of-coins purchase to false
            isLTOPurchase(false);
            _this.setState({
              vipItems: vipItems,
              shopTab: shopTab,
              coinItems: currencyPackages.PACKAGE_LIST.coins.items,
              saleEndDate: saleEndDate,
              isSaleOn: currencyPackages.PACKAGE_LIST.coins.sale,
              coinBackground: currencyPackages.PACKAGE_LIST.coins.sale_background_image,
              promoBoostDialogMessage: currencyPackages.PACKAGE_LIST.coins.message,
              promoBoostPercentage: currencyPackages.PACKAGE_LIST.coins.promo_percentage,
              promoBoostDialogType: promoBoostDialogType,
              showPromoBoost: showPromoBoost
            }, function () {
              return _this.checkToRedeemPromoLink();
            });
            setShopListVip(vipItems);
            _context2.next = 42;
            break;
          case 39:
            _context2.prev = 39;
            _context2.t2 = _context2["catch"](1);
            console.log(_context2.t2);
          case 42:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 39]]);
    }));
    _this._setShopTabHandler = function (newTab) {
      audio.onClick();
      var dismissModal = _this.props.dismissModal;
      switch (newTab) {
        case ShopTabs.BACK:
          {
            dismissModal();
            break;
          }
        case ShopTabs.COINS:
          {
            QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_SHOP_TYPE, paramShopTypes.COINS), RouteParamConstants.PARAM_SKIP_SET_MODAL, true));
            break;
          }
        case ShopTabs.VIP:
          {
            QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_SHOP_TYPE, paramShopTypes.VIP), RouteParamConstants.PARAM_SKIP_SET_MODAL, true));
            break;
          }
        default:
          console.error('Invalid tab');
      }
      _this.setState({
        shopTab: newTab
      });
    };
    _this._buyClickedHandler = function (sku, name, type, amount, trigger) {
      audio.onClick();
      Logger.setActionTrigger(trigger);
      var _this$props2 = _this.props,
        assignTransationUUID = _this$props2.assignTransationUUID,
        coins = _this$props2.coins;
      _this._buyServerHandler(sku, name);
      var platform = Utils.getPlatform();
      var store;
      switch (platform) {
        case PLATFORM.WEB:
          store = 'cams';
          break;
        case PLATFORM.MOBILE_WEB:
          store = 'cams';
          break;
        case PLATFORM.IOS:
          store = 'appstore';
          break;
        default:
          store = platform;
      }
      var id = Logger.generateUUID();
      assignTransationUUID(id);
      var eventPayload = {
        type: type === 'vip_room_access' ? 'vip' : 'regular',
        product_id: sku,
        currency: 'usd',
        store: store,
        balance_before: coins,
        is_test: ENVIRONMENT_VARIABLES.ENVIRONMENT !== 'PROD' ? 1 : 0,
        amount: amount,
        id: id,
        trigger: trigger
      };
      Logger.sendEvent(EVENT_TYPES.TRANSACTION_INITIATED, eventPayload);
    };
    _this._promoBoostDialogButtonHandler = function () {
      audio.onClick();
      _this.setState({
        promoBoostDialogType: null
      });
    };
    _this.checkToRedeemPromoLink = function () {
      var promoLink = _this.props.promoLink;
      if (promoLink && promoLink.code) {
        Logger.sendEvent(EVENT_TYPES.PROMOLINK_CLICKED, {
          code: promoLink.code
        });
      }
      var _this$state = _this.state,
        promoBoostDialogType = _this$state.promoBoostDialogType,
        promoBoostDialogMessage = _this$state.promoBoostDialogMessage,
        coinItems = _this$state.coinItems;
      var _this$props3 = _this.props,
        activatePromocode = _this$props3.activatePromocode,
        setShopListCoins = _this$props3.setShopListCoins,
        dismissInvalidPromocode = _this$props3.dismissInvalidPromocode;
      if (promoBoostDialogType !== null && !!promoBoostDialogMessage) {
        if (promoBoostDialogType === 'success' || _this.promoApplied) {
          _this.setState({
            showPromoBoost: true
          }, function () {
            activatePromocode();
            setShopListCoins(coinItems);
          });
        } else {
          dismissInvalidPromocode();
        }
      }
    };
    _this._hasVIPPass = function () {
      var unlimitedVipAccess = _this.props.unlimitedVipAccess;
      if (unlimitedVipAccess) {
        _this.props.dismissModal();
        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.VipAccessFlow));
      }
    };
    _this._checkIfhasExclusiveSale = function (coinItems) {
      return coinItems.some(function (item) {
        return item.IS_SALE && item.EXCLUSIVE_SALE_PERCENTAGE > 0 && parseInt(item.GENERIC_SALE_PERCENTAGE) === 0;
      });
    };
    _this.state = {
      /** @type {import('../../api/Constants').CurrencyPackageItemKeys[]} */
      coinItems: [],
      vipItems: [],
      shopTab: undefined,
      // Externally loaded, if available. Null otherwise.
      coinBackground: null
    };
    _this.promoApplied = false;
    return _this;
  }
  _inherits(Shop, _Component);
  return _createClass(Shop, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$props4, getRefreshActiveConsumables, clearPurchaseInProgress, isOffer, offerDetail;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this$props4 = this.props, getRefreshActiveConsumables = _this$props4.getRefreshActiveConsumables, clearPurchaseInProgress = _this$props4.clearPurchaseInProgress;
              clearPurchaseInProgress();
              _context3.next = 4;
              return this._getPackages();
            case 4:
              _context3.next = 6;
              return this.checkBillingProfile();
            case 6:
              getRefreshActiveConsumables();
              this._buyServerHandler = buyClickedHandler.bind(this);
              isOffer = QueryParamsProxy.findParam(RouteParamConstants.PARAM_OFFER_ENABLE, null);
              if (isOffer) {
                offerDetail = QueryParamsProxy.findParam(RouteParamConstants.PARAM_OFFER_DETAIL, null);
                this._buyServerHandler(offerDetail.sku, offerDetail.name, '', offerDetail.type);
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props5 = this.props,
        promoLink = _this$props5.promoLink,
        clearPendinMessage = _this$props5.clearPendinMessage;
      (promoLink === null || promoLink === void 0 ? void 0 : promoLink.isFake) && clearPendinMessage();
      QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_SHOP_TYPE, undefined), RouteParamConstants.PARAM_OFFER_ENABLE, undefined));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        render = _this$props6.render,
        assetsUrls = _this$props6.assetsUrls,
        unlimitedVipAccess = _this$props6.unlimitedVipAccess;
      var _this$state2 = this.state,
        shopTab = _this$state2.shopTab,
        newsItems = _this$state2.newsItems,
        coinItems = _this$state2.coinItems,
        vipItems = _this$state2.vipItems,
        isSaleOn = _this$state2.isSaleOn,
        showPromoBoost = _this$state2.showPromoBoost,
        promoBoostDialogType = _this$state2.promoBoostDialogType,
        promoBoostDialogMessage = _this$state2.promoBoostDialogMessage,
        promoBoostPercentage = _this$state2.promoBoostPercentage,
        coinBackground = _this$state2.coinBackground,
        saleEndDate = _this$state2.saleEndDate;
      var hasExclusiveSalePackages = this._checkIfhasExclusiveSale(coinItems);
      return render(
      // Pass state and handlers to platform renderer
      {
        assetsUrls: assetsUrls,
        shopTab: shopTab,
        setShopTabHandler: this._setShopTabHandler,
        newsItems: newsItems,
        coinItems: coinItems,
        vipItems: vipItems,
        buyHandle: this._buyClickedHandler,
        unlimitedVipAccess: unlimitedVipAccess,
        isSaleOn: isSaleOn,
        hasExclusiveSalePackages: hasExclusiveSalePackages,
        showPromoBoost: showPromoBoost,
        promoBoostDialogType: promoBoostDialogType,
        promoBoostDialogMessage: promoBoostDialogMessage,
        promoBoostPercentage: promoBoostPercentage,
        promoBoostDialogButtonHandle: this._promoBoostDialogButtonHandler,
        hasVIPPass: this._hasVIPPass,
        // External assets to load
        coinSale: {
          backgroundImage: coinBackground,
          endDate: saleEndDate
        }
      });
    }
  }]);
}(Component);
Shop.contextType = NotificationContext;
export { Shop as default };
Shop.defaultProps = {
  promoLink: {}
};